import { BinType } from 'commons/enums';

export const COMMODITY_REQUIRED_BIN_TYPES: string[] = [
  BinType.BULKY,
  BinType.RETAIL,
  BinType.LOOSE_CASE,
];

export const isCommodityRequiredForBinType = (binType?: string): boolean =>
  !!binType && COMMODITY_REQUIRED_BIN_TYPES.includes(binType);
